<template>
  <v-container fluid>
    <h1>
      Territory {{ territory.territory_code }}
    </h1>
    <pre>{{ territory }}</pre>

    <v-card>

    </v-card>
  </v-container>
</template>
<script>
import territoryService from '../../services/territoryService';

export default {
  props: {
    territory: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {

    }
  },
  computed: {

  },
  created() {
    console.log('ShowTerritory.vue create()')
  },
  methods: {

  }
}
</script>
